import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "link-extern",
  "use": "link-extern-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"link-extern\"><path fill=\"#FFF\" d=\"M5.677-.007H14v8.324h-2.013l-.002-4.78L1.413 14.113 0 12.699 10.693 2.006H5.677V-.007z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol